import { FIELD_TYPES } from '../constants/field-types';
import { appointmentViewer } from '../fields/appointment/definition-viewer';
import { bookingsAddressViewer } from '../fields/bookings-address/definition-viewer';
import { bookingsEmailViewer } from '../fields/bookings-email/definition-viewer';
import { bookingsFirstNameViewer } from '../fields/bookings-first-name/definition-viewer';
import { bookingsLastNameViewer } from '../fields/bookings-last-name/definition-viewer';
import { bookingsPhoneViewer } from '../fields/bookings-phone/definition-viewer';
import { challengesFileUploadViewer } from '../fields/challenges-file-upload/definition-viewer';
import { challengesImageChoiceViewer } from '../fields/challenges-image-choice/definition-viewer';
import { challengesLongTextViewer } from '../fields/challenges-long-text/definition-viewer';
import { challengesMultiChoiceViewer } from '../fields/challenges-multi-choice/definition-viewer';
import { challengesNumberViewer } from '../fields/challenges-number/definition-viewer';
import { challengesShortTextViewer } from '../fields/challenges-short-text/definition-viewer';
import { challengesSingleChoiceViewer } from '../fields/challenges-single-choice/definition-viewer';
import { checkboxViewer } from '../fields/checkbox/definition-viewer';
import { checkboxGroupViewer } from '../fields/checkbox-group/definition-viewer';
import { contactsAddressViewer } from '../fields/contacts-address/definition-viewer';
import { contactsBirthdateViewer } from '../fields/contacts-birthdate/definition-viewer';
import { contactsCompanyViewer } from '../fields/contacts-company/definition-viewer';
import { contactsEmailViewer } from '../fields/contacts-email/definition-viewer';
import { contactsFirstNameViewer } from '../fields/contacts-first-name/definition-viewer';
import { contactsLastNameViewer } from '../fields/contacts-last-name/definition-viewer';
import { contactsPhoneViewer } from '../fields/contacts-phone/definition-viewer';
import { contactsPositionViewer } from '../fields/contacts-position/definition-viewer';
import { contactsSubscribeViewer } from '../fields/contacts-subscribe/definition-viewer';
import { contactsTaxIdViewer } from '../fields/contacts-tax-id/definition-viewer';
import { dateInputViewer } from '../fields/date-input/definition-viewer';
import { datePickerViewer } from '../fields/date-picker/definition-viewer';
import { dateTimeInputViewer } from '../fields/date-time-input/definition-viewer';
import { dextCheckboxViewer } from '../fields/dext-checkbox/definition-viewer';
import { dextCheckboxGroupViewer } from '../fields/dext-checkbox-group/definition-viewer';
import { dextDatePickerViewer } from '../fields/dext-date-picker/definition-viewer';
import { dextDateTimeInputViewer } from '../fields/dext-date-time-input/definition-viewer';
import { dextDropdownViewer } from '../fields/dext-dropdown/definition-viewer';
import { dextEmailViewer } from '../fields/dext-email/definition-viewer';
import { dextNumberInputViewer } from '../fields/dext-number-input/definition-viewer';
import { dextPhoneViewer } from '../fields/dext-phone/definition-viewer';
import { dextRadioGroupViewer } from '../fields/dext-radio-group/definition-viewer';
import { dextRatingInputViewer } from '../fields/dext-rating-input/definition-viewer';
import { dextTagsViewer } from '../fields/dext-tags/definition-viewer';
import { dextTextAreaViewer } from '../fields/dext-text-area/definition-viewer';
import { dextTextInputViewer } from '../fields/dext-text-input/definition-viewer';
import { dextUrlInputViewer } from '../fields/dext-url-input/definition-viewer';
import { donationViewer } from '../fields/donation/definition-viewer';
import { dropdownViewer } from '../fields/dropdown/definition-viewer';
import { ecomAdditionalInfoViewer } from '../fields/ecom-additional-info/definition-viewer';
import { ecomAddressViewer } from '../fields/ecom-address/definition-viewer';
import { ecomCompanyNameViewer } from '../fields/ecom-company-name/definition-viewer';
import { ecomEmailViewer } from '../fields/ecom-email/definition-viewer';
import { ecomFullNameViewer } from '../fields/ecom-full-name/definition-viewer';
import { ecomPhoneViewer } from '../fields/ecom-phone/definition-viewer';
import { ecomSubscriptionCheckboxViewer } from '../fields/ecom-subscription-checkbox/definition-viewer';
import { eventsRepeaterViewer } from '../fields/events-repeater/definition-viewer';
import { eventsRsvpViewer } from '../fields/events-rsvp/definition-viewer';
import { fileUploadViewer } from '../fields/file-upload/definition-viewer';
import { fixedPaymentViewer } from '../fields/fixed-payment/definition-viewer';
import { fullNameViewer } from '../fields/full-name/definition-viewer';
import { fullNameFirstNameViewer } from '../fields/full-name-first-name/definition-viewer';
import { fullNameLastNameViewer } from '../fields/full-name-last-name/definition-viewer';
import { imageChoiceViewer } from '../fields/image-choice/definition-viewer';
import { mlaAddressLineViewer } from '../fields/mla-address-line/definition-viewer';
import { mlaAddressLine2Viewer } from '../fields/mla-address-line-2/definition-viewer';
import { mlaApartmentViewer } from '../fields/mla-apartment/definition-viewer';
import { mlaCityViewer } from '../fields/mla-city/definition-viewer';
import { mlaCountryViewer } from '../fields/mla-country/definition-viewer';
import { mlaPostalCodeViewer } from '../fields/mla-postal-code/definition-viewer';
import { mlaStreetNameViewer } from '../fields/mla-street-name/definition-viewer';
import { mlaStreetNumberViewer } from '../fields/mla-street-number/definition-viewer';
import { mlaSubdivisionViewer } from '../fields/mla-subdivision/definition-viewer';
import { multilineAddressViewer } from '../fields/multiline-address/definition-viewer';
import { nestedFormViewer } from '../fields/nested-form/definition-viewer';
import { numberInputViewer } from '../fields/number-input/definition-viewer';
import { passwordViewer } from '../fields/password/definition-viewer';
import { paymentInputViewer } from '../fields/payment-input/definition-viewer';
import { phoneViewer } from '../fields/phone/definition-viewer';
import { productListViewer } from '../fields/product-list/definition-viewer';
import { quizCheckboxGroupViewer } from '../fields/quiz-checkbox-group/definition-viewer';
import { quizImageChoiceViewer } from '../fields/quiz-image-choice/definition-viewer';
import { quizNumberInputViewer } from '../fields/quiz-number-input/definition-viewer';
import { quizRadioGroupViewer } from '../fields/quiz-radio-group/definition-viewer';
import { quizTextInputViewer } from '../fields/quiz-text-input/definition-viewer';
import { radioGroupViewer } from '../fields/radio-group/definition-viewer';
import { ratingInputViewer } from '../fields/rating-input/definition-viewer';
import { serviceDropdownViewer } from '../fields/service-dropdown/definition-viewer';
import { servicesMultiChoiceViewer } from '../fields/services-multi-choice/definition-viewer';
import { signatureViewer } from '../fields/signature/definition-viewer';
import { tagsViewer } from '../fields/tags/definition-viewer';
import { textAreaViewer } from '../fields/text-area/definition-viewer';
import { textInputViewer } from '../fields/text-input/definition-viewer';
import { timeInputViewer } from '../fields/time-input/definition-viewer';
import { urlInputViewer } from '../fields/url-input/definition-viewer';
import { vatIdViewer } from '../fields/vat-id/definition-viewer';
export const FIELD_VIEWERS = {
    [FIELD_TYPES.APPOINTMENT]: appointmentViewer,
    [FIELD_TYPES.BOOKINGS_ADDRESS]: bookingsAddressViewer,
    [FIELD_TYPES.BOOKINGS_EMAIL]: bookingsEmailViewer,
    [FIELD_TYPES.BOOKINGS_FIRST_NAME]: bookingsFirstNameViewer,
    [FIELD_TYPES.BOOKINGS_LAST_NAME]: bookingsLastNameViewer,
    [FIELD_TYPES.BOOKINGS_PHONE]: bookingsPhoneViewer,
    [FIELD_TYPES.CHALLENGES_FILE_UPLOAD]: challengesFileUploadViewer,
    [FIELD_TYPES.CHALLENGES_IMAGE_CHOICE]: challengesImageChoiceViewer,
    [FIELD_TYPES.CHALLENGES_LONG_TEXT]: challengesLongTextViewer,
    [FIELD_TYPES.CHALLENGES_MULTI_CHOICE]: challengesMultiChoiceViewer,
    [FIELD_TYPES.CHALLENGES_NUMBER]: challengesNumberViewer,
    [FIELD_TYPES.CHALLENGES_SHORT_TEXT]: challengesShortTextViewer,
    [FIELD_TYPES.CHALLENGES_SINGLE_CHOICE]: challengesSingleChoiceViewer,
    [FIELD_TYPES.CHECKBOX]: checkboxViewer,
    [FIELD_TYPES.CHECKBOX_GROUP]: checkboxGroupViewer,
    [FIELD_TYPES.CONTACTS_ADDRESS]: contactsAddressViewer,
    [FIELD_TYPES.CONTACTS_BIRTHDATE]: contactsBirthdateViewer,
    [FIELD_TYPES.CONTACTS_COMPANY]: contactsCompanyViewer,
    [FIELD_TYPES.CONTACTS_EMAIL]: contactsEmailViewer,
    [FIELD_TYPES.CONTACTS_FIRST_NAME]: contactsFirstNameViewer,
    [FIELD_TYPES.CONTACTS_LAST_NAME]: contactsLastNameViewer,
    [FIELD_TYPES.CONTACTS_PHONE]: contactsPhoneViewer,
    [FIELD_TYPES.CONTACTS_POSITION]: contactsPositionViewer,
    [FIELD_TYPES.CONTACTS_SUBSCRIBE]: contactsSubscribeViewer,
    [FIELD_TYPES.CONTACTS_TAX_ID]: contactsTaxIdViewer,
    [FIELD_TYPES.DATE_INPUT]: dateInputViewer,
    [FIELD_TYPES.DATE_PICKER]: datePickerViewer,
    [FIELD_TYPES.DATE_TIME_INPUT]: dateTimeInputViewer,
    [FIELD_TYPES.DEXT_CHECKBOX]: dextCheckboxViewer,
    [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: dextCheckboxGroupViewer,
    [FIELD_TYPES.DEXT_DATE_PICKER]: dextDatePickerViewer,
    [FIELD_TYPES.DEXT_DATE_TIME_INPUT]: dextDateTimeInputViewer,
    [FIELD_TYPES.DEXT_DROPDOWN]: dextDropdownViewer,
    [FIELD_TYPES.DEXT_EMAIL]: dextEmailViewer,
    [FIELD_TYPES.DEXT_NUMBER_INPUT]: dextNumberInputViewer,
    [FIELD_TYPES.DEXT_PHONE]: dextPhoneViewer,
    [FIELD_TYPES.DEXT_RADIO_GROUP]: dextRadioGroupViewer,
    [FIELD_TYPES.DEXT_RATING_INPUT]: dextRatingInputViewer,
    [FIELD_TYPES.DEXT_TAGS]: dextTagsViewer,
    [FIELD_TYPES.DEXT_TEXT_AREA]: dextTextAreaViewer,
    [FIELD_TYPES.DEXT_TEXT_INPUT]: dextTextInputViewer,
    [FIELD_TYPES.DEXT_URL_INPUT]: dextUrlInputViewer,
    [FIELD_TYPES.DONATION]: donationViewer,
    [FIELD_TYPES.DROPDOWN]: dropdownViewer,
    [FIELD_TYPES.ECOM_ADDITIONAL_INFO]: ecomAdditionalInfoViewer,
    [FIELD_TYPES.ECOM_ADDRESS]: ecomAddressViewer,
    [FIELD_TYPES.ECOM_COMPANY_NAME]: ecomCompanyNameViewer,
    [FIELD_TYPES.ECOM_EMAIL]: ecomEmailViewer,
    [FIELD_TYPES.ECOM_FULL_NAME]: ecomFullNameViewer,
    [FIELD_TYPES.ECOM_PHONE]: ecomPhoneViewer,
    [FIELD_TYPES.ECOM_SUBSCRIPTION]: ecomSubscriptionCheckboxViewer,
    [FIELD_TYPES.EVENTS_REPEATER]: eventsRepeaterViewer,
    [FIELD_TYPES.EVENTS_RSVP]: eventsRsvpViewer,
    [FIELD_TYPES.FILE_UPLOAD]: fileUploadViewer,
    [FIELD_TYPES.FIXED_PAYMENT]: fixedPaymentViewer,
    [FIELD_TYPES.FULL_NAME]: fullNameViewer,
    [FIELD_TYPES.FULL_NAME_FIRST_NAME]: fullNameFirstNameViewer,
    [FIELD_TYPES.FULL_NAME_LAST_NAME]: fullNameLastNameViewer,
    [FIELD_TYPES.IMAGE_CHOICE]: imageChoiceViewer,
    [FIELD_TYPES.MLA_ADDRESS_LINE]: mlaAddressLineViewer,
    [FIELD_TYPES.MLA_ADDRESS_LINE_2]: mlaAddressLine2Viewer,
    [FIELD_TYPES.MLA_APARTMENT]: mlaApartmentViewer,
    [FIELD_TYPES.MLA_CITY]: mlaCityViewer,
    [FIELD_TYPES.MLA_COUNTRY]: mlaCountryViewer,
    [FIELD_TYPES.MLA_POSTAL_CODE]: mlaPostalCodeViewer,
    [FIELD_TYPES.MLA_STREET_NAME]: mlaStreetNameViewer,
    [FIELD_TYPES.MLA_STREET_NUMBER]: mlaStreetNumberViewer,
    [FIELD_TYPES.MLA_SUBDIVISION]: mlaSubdivisionViewer,
    [FIELD_TYPES.MULTILINE_ADDRESS]: multilineAddressViewer,
    [FIELD_TYPES.NESTED_FORM]: nestedFormViewer,
    [FIELD_TYPES.NUMBER_INPUT]: numberInputViewer,
    [FIELD_TYPES.PASSWORD]: passwordViewer,
    [FIELD_TYPES.PAYMENT_INPUT]: paymentInputViewer,
    [FIELD_TYPES.PHONE]: phoneViewer,
    [FIELD_TYPES.PRODUCT_LIST]: productListViewer,
    [FIELD_TYPES.QUIZ_CHECKBOX_GROUP]: quizCheckboxGroupViewer,
    [FIELD_TYPES.QUIZ_IMAGE_CHOICE]: quizImageChoiceViewer,
    [FIELD_TYPES.QUIZ_NUMBER_INPUT]: quizNumberInputViewer,
    [FIELD_TYPES.QUIZ_RADIO_GROUP]: quizRadioGroupViewer,
    [FIELD_TYPES.QUIZ_TEXT_INPUT]: quizTextInputViewer,
    [FIELD_TYPES.RADIO_GROUP]: radioGroupViewer,
    [FIELD_TYPES.RATING_INPUT]: ratingInputViewer,
    [FIELD_TYPES.SERVICES_DROPDOWN]: serviceDropdownViewer,
    [FIELD_TYPES.SERVICES_MULTI_CHOICE]: servicesMultiChoiceViewer,
    [FIELD_TYPES.SIGNATURE]: signatureViewer,
    [FIELD_TYPES.TAGS]: tagsViewer,
    [FIELD_TYPES.TEXT_AREA]: textAreaViewer,
    [FIELD_TYPES.TEXT_INPUT]: textInputViewer,
    [FIELD_TYPES.TIME_INPUT]: timeInputViewer,
    [FIELD_TYPES.URL_INPUT]: urlInputViewer,
    [FIELD_TYPES.VAT_ID]: vatIdViewer
};

//# sourceMappingURL=field-viewers.js.map